import * as React from 'react';
export var CardStatus = function (_a) {
    var children = _a.children, title = _a.title;
    return (<div className='w-full h-full px-4 max-w-full flex flex-grow flex-col mb-2 text-right undefined justify-between'>
		<h5 className='text-gray-500 font-light tracking-wide text-base mb-1'>{title}</h5>
		<span className='text-3xl text-gray-900'>{children}</span>
	</div>);
};
CardStatus.displayName = 'UI.Card.CardStatus';
